<template>
  <b-form-checkbox
    class="event-checkbox"
    :class="{ 'event-checkbox__empty': isSlotEmpty, 'event-checkbox__altcolor': altcolor }"
    switch
    :unchecked-value="uncheckedValue"
    :value="checkedValue"
    :checked="value"
    :disabled="disabled"
    @change="$emit('input', $event)"
  >
    <slot v-if="!isSlotEmpty" />
  </b-form-checkbox>
</template>
<script>
export default {
  props: {
    value: [Boolean, String],
    checkedValue: {
      type: [Boolean, String],
      default: true,
    },
    uncheckedValue: {
      type: [Boolean, String],
      default: false,
    },
    altcolor: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isSlotEmpty() {
      return !this.$slots.default || this.$slots.default.length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.event-checkbox {
  width: 100%;
  padding-inline-end: 52px;
  padding-inline-start: var(--padding-left);
  @media (max-width: 768px) {
    padding-inline-start: 0;
  }

  &__altcolor {
    --event-primary: var(--event-success);
  }

  ::v-deep .custom-control-label {
    width: 100%;
    cursor: pointer;

    [dir="rtl"] & {
      text-align: right;
    }
  }

  ::v-deep .custom-control-label::before {
    top: 0px;
    right: -52px;
    left: unset;
    width: 52px;
    height: 30px;
    border: var(--event-border) solid 1px;
    border-radius: 9999px;
    background-color: var(--event-border) !important;
    box-shadow: none !important;

    [dir="rtl"] & {
      left: -52px;
      right: unset;
    }
  }

  ::v-deep .custom-control-label::after {
    top: 4px;
    right: -26px;
    left: unset;
    width: 22px;
    height: 22px;
    border-radius: 9999px;
    background-color: var(--event-white);

    [dir="rtl"] & {
      left: -26px;
      right: unset;
    }
  }

  ::v-deep .custom-control-input:checked ~ .custom-control-label::after {
    background-color: var(--event-white);
    transform: translateX(22px);

    [dir="rtl"] & {
      transform: translateX(-22px);
    }
  }

  ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
    color: var(--event-white);
    border-color: var(--event-primary);
    background-color: var(--event-primary) !important;
  }

  &__empty {
    width: auto;
    padding-left: 0;

    [dir="rtl"] & {
      padding-right: 0;
    }
  }
}
</style>
